import { State } from './types';

export const initialState: State = {
	projectId: null,
	byProjectId: {}
};
